import { apiGet } from "./client.ts";

export interface Voice {
  id: string;
  name: string;
  description: string;
  gender: string;
  accent: string;
  age: string;
  useCase: string;
  previewUrl: string | null;
  provider: "elevenlabs";
}

export const voicesApi = {
  list: () => apiGet<{ voices: Voice[] }>("/voices"),
};
